import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActiveRateCodeComponent } from './active-rate-code/active-rate-code.component';
import { ActiveRateCodeReportComponent } from './active-rate-code-report/active-rate-code-report.component';
import { AuthGaurdService } from '../service/auth-gaurd.service';
import { PayrollReportComponent } from './payroll-report/payroll-report.component';

const routes: Routes = [
  { path: 'active-rate-code', component: ActiveRateCodeComponent, canActivate: [AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] } },
  { path: 'payroll-report', component: PayrollReportComponent, canActivate: [AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }},
  { path: 'active-rate-code-report', component: ActiveRateCodeReportComponent, canActivate: [AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
